import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";

/**
 * Small, unobtrusive "How it works" link that opens the matching in-app guide.
 * Drop it next to a screen/section title so help is right where people get stuck.
 *
 *   <GuideLink slug="record" />
 *   <GuideLink slug="simulcast" label="Simulcast help" />
 */
export function GuideLink({ slug, label = "How it works", className = "" }) {
  return (
    <Link
      to={`/portal/guides/${slug}`}
      data-testid={`guide-link-${slug}`}
      className={`inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded ${className}`}
    >
      <HelpCircle className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </Link>
  );
}

export default GuideLink;
